<div class="modal-header">
  <h4 class="modal-title">
    {{ 'history.title' | translate }}
    <span
      class="sub-h4"
      [translate]="'history.subtitle'"
      [translateParams]="{ times: sentTimes, totalTimes: totalTimes }"
      *ngIf="policyNo"
    ></span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" id="sentHistoryBody">
  <div class="text-danger text-center" *ngIf="!policyNo">
    {{ 'result.serviceError' | translate }}
  </div>
  <div *ngIf="policyNo">
    <span class="mr-2 font-weight-bold">{{ 'history.policyNo' | translate }}</span>
    <span class="mr-2 font-weight-bold">:</span>{{ policyNo }}
    <table class="table table-bordered dataTable">
      <thead>
        <tr class="table-row row-centered">
          <th class="col col-xl-3 col-fix-lg">{{ 'history.email' | translate }}</th>
          <th class="col col-xl-3 col-fix-md">{{ 'history.mobileNo' | translate }}</th>
          <th class="col col-xl-3 col-fix-md">{{ 'history.sentDate' | translate }}</th>
          <th class="col col-xl-3">{{ 'history.sentBy' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row" *ngFor="let sendRecord of sendRecords">
          <td
            class="col col-xl-3 col-fix-lg"
            [ngStyle]="{ 'text-align': sendRecord.emailTo === null ? 'center' : 'left' }"
          >
            {{ sendRecord.emailTo ? sendRecord.emailTo.join(', ') : '-' }}
          </td>
          <td
            class="col col-xl-3 col-fix-md"
            [ngStyle]="{ 'text-align': sendRecord.mobileNo === null ? 'center' : 'left' }"
          >
            {{ sendRecord.mobileNo ? sendRecord.mobileNo : '-' }}
          </td>
          <td class="col col-xl-3 col-fix-md">{{ sendRecord.sendDate | datetimeLocale: lang }}</td>
          <td class="col col-xl-3">{{ sendRecord.sendBy }}</td>
        </tr>
      </tbody>
      <tbody *ngIf="!sendRecords || sendRecords.length === 0">
        <tr class="table-row">
          <td class="text-center text-danger" colspan="4">
            {{ 'result.notFound' | translate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
